import { render, staticRenderFns } from "./InvestorCardFilter.vue?vue&type=template&id=160872b8&scoped=true&"
import script from "./InvestorCardFilter.vue?vue&type=script&lang=js&"
export * from "./InvestorCardFilter.vue?vue&type=script&lang=js&"
import style0 from "./InvestorCardFilter.vue?vue&type=style&index=0&id=160872b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160872b8",
  null
  
)

export default component.exports